import { usePrevious } from "@chakra-ui/react";
import { useMemo } from "react";

export function useTabActive(tabIndex: number, activeTab: number) {
  const prevActiveTab = usePrevious(activeTab);

  const isTabChanged = useMemo(
    () => typeof prevActiveTab === "number" && prevActiveTab !== activeTab,
    [prevActiveTab, activeTab],
  );
  const isActive = useMemo(() => activeTab === tabIndex, [activeTab, tabIndex]);
  const isTabChangedAndActive = useMemo(() => isTabChanged && isActive, [isTabChanged, isActive]);
  return {
    isActive,
    isTabChanged,
    isTabChangedAndActive,
  };
}
